import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import BookingsTabs from './bookings-tabs'
import { makeStyles } from '@material-ui/styles'
import ScheduleOnboarding from './schedule-onboarding'
import { flags, useFeatureFlags } from 'lib/feature-flags'

export const useStyles = makeStyles(theme => ({
  root: {
    margin: '0 40px',
    [theme.breakpoints.down('xs')]: {
      margin: '20px 10px',
    },
  },
}))

const SchedulePage = ({ selectedTab, onboardingSchedule }) => {
  const classes = useStyles()
  const [isCoachOnboardingEnabled] = useFeatureFlags([
    flags.FLAG_COACH_ONBOARDING,
  ])
  return (
    <Box className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          {!isCoachOnboardingEnabled ? (
            <BookingsTabs selectedTab={selectedTab} />
          ) : (
            <>
              {onboardingSchedule.isGroupEventCreated ||
              onboardingSchedule.isBookingTypeCreated ? (
                <BookingsTabs selectedTab={selectedTab} />
              ) : (
                <ScheduleOnboarding onboardingSchedule={onboardingSchedule} />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default SchedulePage
